import React, { useState, useEffect } from 'react';
import './AlertaGenerador.css';

const AlertaGenerador = ({  logo, title, iluminar = true }) => {
  const [mostrarBorde, setMostrarBorde] = useState(iluminar);
  // Quitar borde iluminado tras 3s
  useEffect(() => {
    const timer = setTimeout(() => setMostrarBorde(false), 3000);
    return () => clearTimeout(timer);
  }, []);

  // Renderizado de título con saltos de línea
  const renderTitle = () => {
    if (title === 'Sin Comunicación con Generador') {
      const partes = title.split(' con ');
      return (
        <>
          <span>{partes[0]}</span>
          <br />
          <span> con {partes[1]}</span>
        </>
      );
    } else if (title === 'Error Contacto Seco al Generador') {
      const partes = title.split(' al ');
      return (
        <>
          <span>{partes[0]}</span>
          <br />
          <span> al {partes[1]}</span>
        </>
      );
    } else if (title.includes('**')) {
      const partes = title.split('**').map(p => p.trim());
      return (
        <>
          {partes.map((parte, idx) => (
            <React.Fragment key={idx}>
              <span>{parte}</span>
              {idx < partes.length - 1 && <br />}
            </React.Fragment>
          ))}
        </>
      );
    }
    return title;
  };

  return (
      <div
        className="alert-generador"
        tabIndex={0}
        aria-label={title}
      >
        <div className="drag-handle">
          <span className="title-generador">{renderTitle()}</span>
        </div>
        <img
          src={logo}
          className={`icon-generador ${mostrarBorde ? 'border-illuminada' : ''}`}
          alt={title}
        />
      </div>
  );
};

export default AlertaGenerador;
